import { render, staticRenderFns } from "./music.vue?vue&type=template&id=25a4a575&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports